export enum QuoteTypeFromNewQuote {
  ShipmentOrder = 'Shipment order',
  RollOut = 'Roll-out',
}
